import { render } from "./UserSignupPage.vue?vue&type=template&id=3a72d467&scoped=true"
import script from "./UserSignupPage.vue?vue&type=script&lang=js"
export * from "./UserSignupPage.vue?vue&type=script&lang=js"

import "./UserSignupPage.vue?vue&type=style&index=0&id=3a72d467&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a72d467"]])

export default __exports__